module.exports = __webpack_public_path__ + "static/media/select-chk.63a31481.svg";